import React, { Component } from "react";
import { Button } from "reactstrap";
import { UncontrolledTooltip } from "reactstrap";
import ModalArea from '../ModalArea';
import { async } from 'q';
import { fetchData } from "../common/networkRequests";
import { generateOtherValues, setCookie, simple_csv_download } from "../oro-module/commonFunctions";
import { RelevantIcon } from "../oro-module/RelevantIcon";
import { getObjectsValue } from "../../pages/commonFunctions";
import { validateRow, createGridRows } from "./BusinessLogic/ContraEntries";



class ButtonCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      modalProps: false,
      btnclicked: false,
      btnclass: {}
    };
  }

  generateID = () => {
    return this.state.ttid;
  };
  // generateOtherValues = (sendData) => {
  //   let { pageData, openmodals } = this.props.parentState;
  //   let returnVal = {}
  //   if (sendData.length != 0) {
  //     sendData.map(otherfield => {
  //       if (otherfield.varname) {
  //         returnVal[otherfield.varname] = getObjectsValue(pageData, otherfield.value);
  //       } else {
  //         returnVal[otherfield] = getObjectsValue(pageData, otherfield);
  //       }
  //     })
  //   }
  //   return returnVal
  // }

  // handleAppendModal = () => {
  //   let name = this.props.component.name;
  //   console.log("hi")
  //   this.setState({ modalProps: true });
  //   let om = this.props.parentState.openmodals;
  //   om.push(name + "_search");
  //   this.props.liftGlobalState({ name: "openmodals" }, om);

  // }


  addToHTMLTable = (current) => {


  }


  handleClick = async () => {
    this.setState({ btnclicked: true });

    const { onclick, requiredValue, convertedTo, name } = this.props.component;
    let { parentState } = this.props;
    const { currentPage, LocalVars, pageData, modalname, remoteip, controlsData } = parentState;
    let commonControlsFooters = new Object(controlsData);
    let { hotdata } = LocalVars;
    let { parentName, st } = this.state;
    let { token } = this.props.parentProps.parentState;

    let CBSurl = `${remoteip}/sentry`;
    let method = 'post';
    let actions = [];
    if (typeof (onclick.action) == 'string') {
      actions = [{ act: onclick.action, acttype: onclick.acttype }];
    } else {
      actions = onclick.action;
    }

    for (var i = 0; i < actions.length; i++) {
      let action = actions[i];
      // if download a file.
      if (action.act == "closeTab") {
        window.close()
      }
      else if (action.act == "handleAppendmodal") {
        this.setState({ modalProps: true });
        let om = parentState.openmodals;
        om.push(name);
        this.props.liftGlobalState({ name: "modalWidth" }, 1000);
      } else if (action.act == 'handleOpenNewtab') {
        let unique_id;
        if (this.props.component.unique_id) {
          unique_id = getObjectsValue(parentState, this.props.component.unique_id);
        } else {
          unique_id = pageData.unique_id;
        }
        let { pagename, form, payload } = this.props.component;
        let def = { set: {} };
        if (payload) {
          for (var key in payload) {
            if (typeof payload[key] == 'string') {
              def['set'][key] = getObjectsValue(parentState, payload[key]);
            } else {
              // Check 
              if (payload[key].type == 'fixed') {
                def['set'][key] = payload[key]['value'];
              } else {
                def['set'][key] = payload[key]['formula'];
              }
            }
          }
        }
        if (form) {
          def['unique_id'] = unique_id;
        }

        let identi = Math.round(Math.random() * 10000000000);
        setCookie(identi, JSON.stringify(def));

        let url;
        if (unique_id) {
          url = "/" + pagename + "/" + identi;
        }
        window.open(url, '_blank');
      } else if (action.act == 'checkAAdharUID') {
        let { dataType, sendData } = action.sendToServer;
        let saveThis = { dataType, dependantOnValues: sendData && generateOtherValues(sendData, pageData) };
        let { results, exceptions, vendorErrors, error } = await fetchData({ url: CBSurl, postData: saveThis, method, headers: { Authorization: `JWT ${token}` } });
        if (results) {
          if (Object.keys(results).length != 0) {
            // this.props.liftState({ name: 'customer_number' }, results[0]);
            this.props.liftState({ name: 'unlink_message' }, `AADHAAR present for Customer No ${results[0]}`);

            console.log({ C: pageData.customer_number, R: results[0] });
            if (String(results[0]) != String(pageData.customer_number)) {
              this.props.liftState({ name: "aadhaarMessage" }, `Typed Aadhaar No ${pageData.aadhar_id} does not match ${pageData['aadhar_id_on_file']} the one on the customer file`);
            }
          } else {
            // show warning message, AADHAAR not linked.
            this.props.liftState({ name: 'unlink_message' }, "✓ New AADHAAR. Not associated with any account.");
          }
          this.props.liftState({ name: 'unlinked' }, 1);
        } else {
          this.props.liftState({ name: 'unlinked' }, 0);
        }
      } else if (action.act == 'unlockAccountNumber') {
        let { dataType, sendData } = action.sendToServer;
        let saveThis = { dataType, dependantOnValues: sendData && generateOtherValues(sendData, pageData), currentPage };
        // The following request should be non blocking.
        let { results, exceptions, vendorErrors, error } = fetchData({ url: CBSurl, postData: saveThis, method, headers: { Authorization: `JWT ${token}` } });
      } else if (action.act == 'cdFlagbutton') {
        let { name, style } = this.props.component
        this.props.liftState({ name: action.name }, action.value);
      }
      else if (action.act == 'getLastCachedReport') {
        this.props.liftState({ name: 'is_cached' }, true);
        setTimeout(() => document.getElementById('action-button-search').click(), 10);
        setTimeout(() => this.props.liftState({ name: 'is_cached' }, false), 500);
      }
      else if (action.act == 'clearHTMLTableForm') {

        // check if required fields are filled. If yes then proceed.
        let { tableNameField, requiredField, removeExcept, required } = onclick;
        let fieldData;
        if (modalname) {
          fieldData = pageData[modalname];
        } else {
          fieldData = pageData;
        }
        if (!fieldData) { fieldData = {}; }

        // Clear the current form.
        requiredField.map(fld => {
          delete fieldData[fld];
        });
        // Check if other fields are to be removed forcefully.
        if (removeExcept) {
          for (var key in fieldData) {
            // console.log(key)
            if (removeExcept.indexOf(key) == -1 && key != tableNameField) {
              delete fieldData[key];
            }
          }
        }
        // console.log({fieldData})
        this.props.liftGlobalState({ name: 'errorMessages' }, {});
      }
      else if (action.acttype && action.acttype == 'serverfunc') {
        try {
          if (onclick.action == 'generateLoanSchedule') {
            let { tableNameField, requiredField, removeExcept, required, extra, otherdata } = onclick;
            let formData = {};
            otherdata.map(od => formData[od] = pageData[od]);
            console.log({ formData, otherdata });

            let { results, exceptions, vendorErrors, error } = await fetchData({ current: this, url: CBSurl, postData: { dataType: action.acttype, name: action.act, formData }, method: "POST", headers: { Authorization: `JWT ${token}` } });

            this.props.liftState({ name: tableNameField }, results.schedule);
            this.props.liftState({ name: "account_installment.installment_amount" }, results.emi);
            this.props.liftState({ name: "account_installment.interest_rate" }, results.interest_rate);
            this.props.liftState({ name: "account_installment.total_interest" }, results.total_interest);
            this.props.liftState({ name: "account_installment.expiry_date" }, results.expiry_date);
            this.props.liftState({ name: "account_installment.total_recoverable_amount" }, results.recoverable_amount);

          } else if (onclick.action == 'generateTDSchedule') {
            let { tableNameField, requiredField, removeExcept, required, extra, otherdata } = onclick;
            let formData = {};
            otherdata.map(od => formData[od] = pageData[od]);

            let { results, exceptions, vendorErrors, error } = await fetchData({ current: this, url: CBSurl, postData: { dataType: action.acttype, name: action.act, formData }, method: "POST", headers: { Authorization: `JWT ${token}` } });

            this.props.liftState({ name: tableNameField }, results.schedule);
            this.props.liftState({ name: "term_deposit.maturity_amount" }, results.maturity_amount);
            this.props.liftState({ name: "term_deposit.interest_rate" }, results.interest_rate);
            this.props.liftState({ name: "term_deposit.is_auto_renew" }, results.is_auto_renew);
            this.props.liftState({ name: "term_deposit.interest_payable" }, results.total_interest);
            this.props.liftState({ name: "term_deposit.maturity_date" }, results.maturity_date);
            this.props.liftState({ name: "expiry_date" }, results.maturity_date);

          }
          else if (onclick.action == 'generateRDSchedule') {
            let { tableNameField, requiredField, removeExcept, required, extra, otherdata } = onclick;
            let formData = {};
            otherdata.map(od => formData[od] = pageData[od]);

            let { results, exceptions, vendorErrors, error } = await fetchData({ current: this, url: CBSurl, postData: { dataType: action.acttype, name: action.act, formData }, method: "POST", headers: { Authorization: `JWT ${token}` } });

            this.props.liftState({ name: tableNameField }, results.schedule);
            this.props.liftState({ name: "recurring_deposit.maturity_amount" }, results.maturity_amount);
            this.props.liftState({ name: "recurring_deposit.interest_rate" }, results.interest_rate);
            this.props.liftState({ name: "recurring_deposit.is_auto_renew" }, results.is_auto_renew);
            this.props.liftState({ name: "recurring_deposit.interest_payable" }, results.total_interest);
            this.props.liftState({ name: "recurring_deposit.maturity_date" }, results.maturity_date);
            this.props.liftState({ name: "expiry_date" }, results.maturity_date);
          }
          else if (onclick.action == 'reconcileCalamityFund') {
            this.props.liftGlobalState({ name: 'isSearching' }, true);

            let { tableNameField, requiredField, removeExcept, required, extra, otherdata } = onclick;
            let formData = {};
            otherdata.map(od => formData[od] = pageData[od]);

            let { results, exceptions, vendorErrors, error } = await fetchData({ current: this, url: CBSurl, postData: { dataType: action.acttype, name: action.act, formData }, method: "POST", headers: { Authorization: `JWT ${token}` } });
            this.props.liftGlobalState({ name: 'isSearching' }, false);

            this.props.liftGlobalState({ name: 'timeTaken' }, 100);
            this.props.liftGlobalState({ name: 'OriginalData' }, results);
          }
        }
        catch (e) {
          console.log({ e })
        }
      }
      else if (action.act == 'appendToHTMLTable') {
        // check if required fields are filled. If yes then proceed.
        let { tableNameField, requiredField, removeExcept, required, extra, removeAlso, fixedValue } = onclick;
        if (!extra) { extra = {}; }
        let fieldData;
        if (modalname) {
          fieldData = pageData[modalname];
        } else {
          fieldData = pageData;
        }
        if (!fieldData) { fieldData = {}; }
        let tableVals = fieldData[tableNameField] ? fieldData[tableNameField] : [];
        let recordNo = tableVals.length;
        let temp = {}; let shouldAdd = true; let requiredCols = {};
        let tableErrors = {};

        // Check if all the required fields are filled.
        requiredField && requiredField.map(head => {
          if (!fieldData[head] && required && required.indexOf(head) != -1) {
            shouldAdd = false;
            tableErrors[head] = "Required";
          }
        })
        let unq = "";
        // create table row.
        if (shouldAdd) {
          requiredField.map(head => {
            if (!fieldData[head] && extra[head]) {
              if (extra[head].type == 'var') {
                temp[head] = getObjectsValue(parentState, extra[head].value);
              } else {
                temp[head] = extra[head].value;
              }
            }
            else {
              temp[head] = fieldData[head];
            }
            // If we only send non empty fields, then it is not possible to unset them in the backend.
            // else if (fieldData[head]) {
            //   temp[head] = fieldData[head];
            // }
            unq += head.indexOf('_uid') == -1 ? head : "";
            if (fixedValue) {
              for (var key in fixedValue) {
                temp[key] = fixedValue[key];
              }
            }
          });
          //  temp['srno'] = recordNo;

          let unqdata = this.props.parentState[unq];
          if (unqdata) {
            temp["unique_id"] = unqdata;
            delete this.props.parentState[unq];
          }
          let finalRows = [temp];


          tableVals = finalRows.concat(tableVals);// tableVals.concat(finalRows);
          this.props.liftState({ name: tableNameField }, tableVals);

          // Clear the current form.

          if (removeExcept) {
            requiredField.map(fld => {
              if (removeExcept.indexOf(fld) == -1) {
                fieldData[fld] = "";
              }
            });
          } else {
            requiredField.map(fld => {
              fieldData[fld] = "";
            });
          }

          if (removeAlso) {
            removeAlso.map(ra => fieldData[ra] = '');
          }
        } else {
          let err = this.props.errorMessages;
          if (!err) { err = {}; }
          if (modalname) {
            err[modalname] = tableErrors;
          } else {
            err = tableErrors;
          }
          this.props.liftGlobalState({ name: 'errorMessages' }, err);
        }
      }
      else if (action.act == 'downloadSample') {
        let { tableNameField, requiredField, removeExcept, required } = onclick;
        simple_csv_download({ rows: [requiredField], filename: currentPage + "_sample" })
      }

    }
    this.setState({ btnclicked: false });

  };

  liftControlsState = (stateName, stateValue) => {
    this.setState({ [stateName]: stateValue });
  }

  render() {
    let {
      name,
      Bcolor,
      style,
      parentStyle,
      size,
      label,
      buttonfocus,
      placeHolder,
      isRequired,
      isReadOnly,
      description,
      Blocktype,
      icon
    } = this.props.component;
    let { conditionalRender } = this.props;
    let { compressed } = this.props.parentState.LocalVars;

    const tooltipID = this.generateID();
    let classval = "";
    let classval1 = "";
    let buttontype;
    !style && (style = {});
    !parentStyle && (parentStyle = {});

    !size && (size = "sm");
    compressed && (size = 'lg');
    Blocktype === "block" && (classval = "btn-block");
    Bcolor ? (classval1 = Bcolor) : (classval1 = "info");
    // buttonfocus ? buttontype=buttonfocus 

    return (
      <div
        id={tooltipID}
        style={parentStyle}
        className={`form-group ${this.props.component.widths.parent}`}
      >
        {conditionalRender && conditionalRender != 'blank' && !isReadOnly &&

          <Button
            size={size}
            // outline
            className={`${classval} col-sm-12 `}
            disabled={this.state.btnclicked}
            color={classval1}
            onClick={this.handleClick}
            style={style}
            id={label == 'ADD' ? 'add_to_grid_btn' : name}
          >
            {icon && <RelevantIcon icon={icon} style={{ marginBottom: -3 }} />}
            &nbsp;{label}
          </Button>
        }
        {this.state.modalProps && (
          <ModalArea
            liftState={this.props.liftState}
            liftGlobalState={this.props.liftGlobalState}
            liftWrapperState={this.props.liftWrapperState}
            parentState={this.props.parentState}
            parentProps={this.props.parentProps}
            triggerState={{ st: this.state, parentName: name, currentComponent: this.props.component }}
            liftControlState={this.liftControlsState}
          />
        )}
      </div>
    );
  }
}

export default ButtonCustom;
